import { FEATURE_FLAGS } from '@yi/core';

import { useSiteWideBanner } from '~/src/common/site-wide-banner';
import { useFeatureFlag } from '~/src/components/hooks/useFeatureFlag';
import { useLocale } from '~/src/components/LocaleProvider';

import { LAST_CLOSED_SALE_BANNER_STORAGE_KEY } from './constants';
import { eligablePathsList } from './eligablePathsList';

export const MAY_2025_BANNER_KEY = '2025-may-banner' as const;
export const MAY_2025_LAST_CHANCE_BANNER_KEY = '2025-may-banner-last-chance' as const;

const MAY_2025_PHASE1_SALE_START = '2025-05-22';
const MAY_2025_PHASE2_SALE_START = '2025-06-03';
const MAY_2025_PHASE2_SALE_END = '2025-06-11';

function calculateBannerKey(date: Date) {
  if (date >= new Date(MAY_2025_PHASE1_SALE_START) && date < new Date(MAY_2025_PHASE2_SALE_START)) {
    return MAY_2025_BANNER_KEY;
  } else if (
    date >= new Date(MAY_2025_PHASE2_SALE_START) &&
    date < new Date(MAY_2025_PHASE2_SALE_END)
  ) {
    return MAY_2025_LAST_CHANCE_BANNER_KEY;
  } else {
    return '';
  }
}

export function useShowSaleBanner() {
  const { locale } = useLocale();

  const onSalesBannerFeatureFlag = useFeatureFlag(FEATURE_FLAGS.WEB_SALES_BANNER);
  const { closeBanner, isShown } = useSiteWideBanner({
    isShowingStarted: onSalesBannerFeatureFlag.enabled,
    eligablePathList: eligablePathsList,
    storageKey: LAST_CLOSED_SALE_BANNER_STORAGE_KEY,
  });

  if (onSalesBannerFeatureFlag.loading || locale !== 'en') {
    return {
      isShown: false,
      closeBanner,
      bannerKey: '' as const,
    };
  }

  const bannerKey = calculateBannerKey(new Date());

  return {
    isShown,
    closeBanner,
    bannerKey,
  };
}
